<template>
  <header-view v-if="store.state.userAgent == 'pc'" :change-path="changePath" :hideTitle="hideTitle"></header-view>
  <mobile-header v-if="store.state.userAgent == 'mobile'"></mobile-header>
  <div class="router-wrap" :class="store.state.userAgent == 'pc' ? 'web-wrap' : 'mobile-wrap'">
    <!-- 使用 Vue Router 4 推荐的 slot props 方式实现页面缓存 -->
    <!-- keep-alive 的 include 属性指定需要缓存的组件名称列表 -->
    <!-- 这样切换路由时，被缓存的组件不会被销毁，保持原有状态 -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="keepAliveComponents">
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <bottom-navigation v-if="store.state.userAgent == 'pc'"></bottom-navigation>
    <mobile-bottom-navigation v-if="store.state.userAgent == 'mobile'"></mobile-bottom-navigation>
  </div>
  <contact-us v-if="store.state.userAgent == 'pc'"></contact-us>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import HeaderView from '@/components/HeaderView.vue';
import MobileHeader from '@/components/mobile/HeaderView.vue';
import BottomNavigation from '@/components/BottomNavigation.vue';
import { pathTable } from '@/config'
import ContactUs from '@/components/ContactUs.vue'
import MobileBottomNavigation from '@/components/mobile/BottomNavigation.vue';

const router = useRouter()
const store = useStore()
const hideTitle = ref(false)
// 需要缓存的组件名称列表，与组件的 name 属性对应
// 只有在这里列出的组件才会被 keep-alive 缓存
const keepAliveComponents = ['SolutionView', 'MobileSolution']


const changePath = (path: string) => {
  console.log(path)
}

// 路由拦截，这里主要根据路由确定一些组件的显隐性
router.beforeEach((to, from, next) => {
  hideTitle.value = Boolean((to.meta && to.meta.hideTitle));
  const pathInfo = JSON.stringify({ query: to.query || {} })
  window.sessionStorage.setItem('path', pathInfo)
  const pathName = to.name || ''
  store.state.titleIndex = pathTable[pathName]
  store.state.isBlankBg = pathName
  
  // 检查是否有保持滚动位置的标记
  const keepScrollPosition = window.sessionStorage.getItem('keepScrollPosition');
  
  // 如果有标记或目标页面是缓存页面，不滚动到顶部
  if (!keepScrollPosition && !to.meta.keepAlive) {
    window.scrollTo(0, 0)
  }
  
  // 清除标记，下次导航时恢复默认行为
  if (keepScrollPosition) {
    window.sessionStorage.removeItem('keepScrollPosition');
  }
  
  next();
});

onMounted(() => {
  setRem()
  window.addEventListener('resize', () => {
    setRem()
  }, false)
  // 判断是不是移动端
})

const setRem = () => {
  let rootDom: any = document.querySelector('html');
  let rootWidth = document.documentElement.clientWidth || document.body.clientWidth;

  var userAgent = navigator.userAgent.toLowerCase();
  if (
    userAgent.match(
      /(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|windows mobile|windows ce|ucweb|rv:1.2.3.4|midp)/i
    )
  ) {
    rootDom.style.fontSize = rootWidth / 750 + 'px';
    store.state.userAgent = 'mobile'
  } else {
    rootDom.style.fontSize = Math.min(Math.max(rootWidth / 1920, 0.2), 3) + 'px';
    store.state.userAgent = 'pc'
  }

}
</script>
<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  background-color: rgba(255, 255, 255, 1);
  color: #333333;
}

body {
  font-size: 14rem;
  font-family: PingFangSC-Regular;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.left-radius {
  border-radius: 8rem 0 0 8rem;
}

.right-radius {
  border-radius: 0 8rem 8rem 0;
}

.blods {
  color: #D71819 !important;
  font-weight: 500;
  font-family: PingFangSC-Medium;
}

.form-content,
.form-content-m {
  .el-form-item__label {
    font-weight: 500;
    font-size: 18rem;
    color: #FFFFFF;
  }

  .el-form-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 18rem;
  }

  .el-input__wrapper {
    width: 333rem;
    height: 42rem;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 5rem;
    box-shadow: none !important;
    margin-top: 10rem;

    input {
      border: none !important;
      font-weight: 500;
      font-size: 16rem;
      color: #FFFFFF;

      &::placeholder {
        color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .el-textarea__inner {
    margin-top: 11rem;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 5rem;
    box-shadow: none !important;
    font-weight: 500;
    font-size: 16rem;
    color: #FFFFFF;
    width: 333rem;
    height: 90rem;

    &::placeholder {
      color: rgba(255, 255, 255, 0.2);
    }
  }

  .el-form-item__error {
    font-size: 12rem;
    color: #e54949;
  }

  .btn-primary {
    width: 307rem;
    height: 50rem;
    line-height: 50rem;
    background: #D81417;
    border-radius: 6rem;
    backdrop-filter: blur(4rem);
    cursor: pointer;
    font-weight: 400;
    font-size: 20rem;
    color: #FFFFFF;
    font-family: PingFangSC-Regular;
  }
}

.form-content-m {
  .el-form-item__label {
    color: #414141;
    font-size: 24rem;
  }

  .el-input__wrapper {
    height: 72rem;
    margin: 0;
    border-radius: 8rem;
    border: 2rem solid #F2F2F2;

    input {
      font-size: 24rem;
      color: #414141;
    }

    input::placeholder {
      color: #B2B1B1;
    }
  }

  .el-form-item__content {
    width: 100%;
    background-color: #fff;

  }

  .el-select__wrapper {
    height: 72rem;
    box-shadow: none !important;
    border-radius: 8rem;
    border: 2rem solid #F2F2F2;
    font-size: 24rem;
    color: #414141;
  }

  .el-form-item__error {
    font-size: 18rem;
  }

  .form-submit>.el-form-item__content {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30rem;
  }

  .form-submit{
    margin-bottom: 82rem;
  }

  .btn-primary {
    width: 148rem;
    height: 64rem;
    line-height: 64rem;
    text-align: center;
    background: #D81418;
    border-radius: 6rem;
    font-size: 24rem;
  }

  .el-textarea__inner {
    border-radius: 8rem;
    font-size: 24rem;
    color: #414141;
    width: 100%;
    height: 190rem;
    &::placeholder {
      color: #B2B1B1;
    }
  }
}

.contact-model {
  .form-content {

    .el-input__wrapper,
    .el-textarea__inner {
      width: 458rem;
    }
  }

  .btn-primary {
    width: 458rem;
    margin-top: 10rem;
  }

  .el-select__wrapper {
    width: 458rem;
    height: 44rem;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 5px;
    box-shadow: none !important;
    margin-top: 11rem;

    span {
      border: none !important;
      font-weight: 500;
      font-size: 16rem;
      color: #FFFFFF;
    }

    .is-transparent span {
      color: rgba(255, 255, 255, 0.2);
    }
  }
}

.title-font-style {
  font-weight: 600;
  font-size: 60rem;
  color: #333333;
  font-family: PingFangSC-Medium;
}

.title-font-style-m {
  font-weight: bold;
  font-size: 40rem;
  color: #5D5D5D;
  font-family: PingFangSC-Medium;
}

.router-wrap {
  position: relative;
  padding-bottom: 276rem;
  font-family: PingFangSC-Regular;
  box-sizing: border-box;
  min-height: calc(100vh - 60rem);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &>div {
    width: 100%;
    overflow: hidden;
  }
}

.mobile-wrap {
  padding-bottom: 0;

  .banner {
    height: 348rem;
    position: relative;
    top: 0;
    margin-top: 72rem;
  }

  .news-detail img {
    max-width: 100%;
    height: auto !important;
  }

  .news-detail video {
    max-width: 100%;
    height: auto !important;
  }

  .privacy-policy {
    width: 680rem !important;
    margin-top: 100rem !important;

    .content {
      padding: 0 !important;
    }
  }
  
  .el-carousel__indicators--horizontal {
    transform: none;
    left: calc(375rem - 95px);
  }
}

.banner {
  width: 100vw;
  height: 745rem;
  position: relative;
  top: -60rem;
}

/* 分页器 */
.pagination .el-pagination {
  .el-pager>li {
    width: 32rem;
    min-width: 32rem;
    height: 32rem;
    border: 1px solid #D9D9D9;
    background-color: transparent !important;
    border-radius: 4rem;
    font-size: 14rem !important;

    &.is-active {
      border: 1px solid #D81417;
      background-color: transparent !important;
      color: #D81417 !important;
    }
  }

  .btn-prev,
  .btn-next {
    width: 32rem;
    min-width: 32rem;
    height: 32rem;
    border: 1px solid #D9D9D9;
    background-color: transparent !important;
    border-radius: 4rem;
    color: #000000 !important;

    .el-icon {
      font-size: 14rem !important;
    }
  }
}

.news-detail img {
  max-width: calc(843rem + 17vw);
  height: auto;
}

.news-detail video {
  max-width: calc(843rem + 17vw);
  height: auto;
}
</style>
